import { render, staticRenderFns } from "./CurrencyApprovePopup.vue?vue&type=template&id=2439c774&scoped=true"
import script from "./CurrencyApprovePopup.vue?vue&type=script&lang=js"
export * from "./CurrencyApprovePopup.vue?vue&type=script&lang=js"
import style0 from "./CurrencyApprovePopup.vue?vue&type=style&index=0&id=2439c774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439c774",
  null
  
)

export default component.exports